import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import "../styles/style.css";
import { auth, db, logout } from "../firebase";
import { query, collection, getDocs, where } from "firebase/firestore";
import { Link } from "react-router-dom";
import NavbarLanding from "../components/Navbar/NavbarLanding";
import NavbarDashboard from "../components/Navbar/NavbarDashboard";
import fundamentals_poster from "../assets/images/fundamentals_poster.png";
import ts_rm_poster from "../assets/images/ts_rm_poster.png";
import roadsafety_poster from "../assets/images/road_safety_poster_lck.png";
import fpv_poster from "../assets/images/fpv_poster_lck.png";
import Footer from "../components/footer/footer";
import NoLesson from "../components/no_lesson/no_lesson";

function Dashboard() {
  function completeFirstAlert() {
    alert("Complete the previous lesson first.");
  }

  const [user, loading, error] = useAuthState(auth);
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const fetchUserName = async () => {
    try {
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setName(data.name);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    fetchUserName();
  }, [user, loading]);

  return (
    <div className="container-dashboard">
      <NavbarDashboard />
      <div className="container-dashboard-content">
        <div className="greetings">
          <h1> Welcome {name}, What do you want to learn today?</h1>
        </div>

        <div className="wrapper">
          <NoLesson />
        </div>

        <div className="container-dashboard-content-ind">
          <div className="page-selector-wrapper">
          <Link to="/dashboard" className="page-selector page-selector--active">
            1
          </Link>
          <Link to="/dashboard-page-2" className="page-selector">
            2
          </Link>
          <Link to="#" className="page-selector">
            3
          </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
export default Dashboard;
